module.exports = __webpack_public_path__ + "media/app/images/comments-icon-e63ad8a927a9861cc97be34f7e6e72fe.png";